import axios from 'axios';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const input = node.querySelector('input');
  const group = node.querySelector('.newsletter-inputs');
  const success = node.querySelector('.newsletter-success');

  node.addEventListener('submit', e => {
    e.preventDefault();

    const data = {
      g: node.dataset.id,
      email: input.value,
    };
    const urlData = new URLSearchParams(data);

    fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
      method: 'POST',
      body: urlData,
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        group.classList.add('hidden');
        success.classList.remove('hidden');
      });
  });
});
